@file:OptIn(InternalResourceApi::class)

package diana.soleil.design.iraniancanadienbazzar.feature.gems.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String =
    "composeResources/diana.soleil.design.iraniancanadienbazzar.feature.gems.resources/"

@delegate:ResourceContentHash(-1_610_369_813)
internal val Res.string.gems_adult_chip: StringResource by lazy {
      StringResource("string:gems_adult_chip", "gems_adult_chip", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 358, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 354, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 334, 39),
      ))
    }

@delegate:ResourceContentHash(976_775_572)
internal val Res.string.gems_age_gate_body: StringResource by lazy {
      StringResource("string:gems_age_gate_body", "gems_age_gate_body", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 414, 230),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 394, 170),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 374, 158),
      ))
    }

@delegate:ResourceContentHash(-574_583_101)
internal val Res.string.gems_age_gate_cancel: StringResource by lazy {
      StringResource("string:gems_age_gate_cancel", "gems_age_gate_cancel", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 645, 44),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 565, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 533, 40),
      ))
    }

@delegate:ResourceContentHash(2_016_377_649)
internal val Res.string.gems_age_gate_confirm: StringResource by lazy {
      StringResource("string:gems_age_gate_confirm", "gems_age_gate_confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 690, 97),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 602, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 574, 69),
      ))
    }

@delegate:ResourceContentHash(1_471_235_396)
internal val Res.string.gems_age_gate_note: StringResource by lazy {
      StringResource("string:gems_age_gate_note", "gems_age_gate_note", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 788, 114),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 680, 82),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 644, 66),
      ))
    }

@delegate:ResourceContentHash(1_586_410_096)
internal val Res.string.gems_age_gate_title: StringResource by lazy {
      StringResource("string:gems_age_gate_title", "gems_age_gate_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 903, 79),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 763, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 711, 59),
      ))
    }

@delegate:ResourceContentHash(-1_257_146_232)
internal val Res.string.gems_any_option: StringResource by lazy {
      StringResource("string:gems_any_option", "gems_any_option", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 983, 31),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 835, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 771, 27),
      ))
    }

@delegate:ResourceContentHash(-74_719_876)
internal val Res.string.gems_back_a11y: StringResource by lazy {
      StringResource("string:gems_back_a11y", "gems_back_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1015, 38),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 867, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 799, 30),
      ))
    }

@delegate:ResourceContentHash(-927_761_404)
internal val Res.string.gems_cat_classic: StringResource by lazy {
      StringResource("string:gems_cat_classic", "gems_cat_classic", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1054, 40),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 898, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 830, 36),
      ))
    }

@delegate:ResourceContentHash(-997_999_106)
internal val Res.string.gems_cat_family: StringResource by lazy {
      StringResource("string:gems_cat_family", "gems_cat_family", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1095, 47),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 939, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 867, 31),
      ))
    }

@delegate:ResourceContentHash(1_323_299_391)
internal val Res.string.gems_cat_nostalgia: StringResource by lazy {
      StringResource("string:gems_cat_nostalgia", "gems_cat_nostalgia", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1143, 50),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 975, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 899, 38),
      ))
    }

@delegate:ResourceContentHash(1_967_526_557)
internal val Res.string.gems_cat_observational: StringResource by lazy {
      StringResource("string:gems_cat_observational", "gems_cat_observational", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1194, 62),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1014, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 938, 50),
      ))
    }

@delegate:ResourceContentHash(1_481_760_433)
internal val Res.string.gems_cat_wordplay: StringResource by lazy {
      StringResource("string:gems_cat_wordplay", "gems_cat_wordplay", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1257, 57),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1065, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 989, 37),
      ))
    }

@delegate:ResourceContentHash(19_554_927)
internal val Res.string.gems_coming_soon_desc: StringResource by lazy {
      StringResource("string:gems_coming_soon_desc", "gems_coming_soon_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1315, 129),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1107, 89),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1027, 97),
      ))
    }

@delegate:ResourceContentHash(1_753_561_537)
internal val Res.string.gems_coming_soon_title: StringResource by lazy {
      StringResource("string:gems_coming_soon_title", "gems_coming_soon_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1445, 86),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1197, 82),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1125, 58),
      ))
    }

@delegate:ResourceContentHash(-1_768_584_489)
internal val Res.string.gems_cook_close_a11y: StringResource by lazy {
      StringResource("string:gems_cook_close_a11y", "gems_cook_close_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1532, 68),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1280, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1184, 48),
      ))
    }

@delegate:ResourceContentHash(-2_094_858_473)
internal val Res.string.gems_cook_finish: StringResource by lazy {
      StringResource("string:gems_cook_finish", "gems_cook_finish", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1601, 40),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1341, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1233, 32),
      ))
    }

@delegate:ResourceContentHash(354_982_702)
internal val Res.string.gems_cook_image_a11y: StringResource by lazy {
      StringResource("string:gems_cook_image_a11y", "gems_cook_image_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1642, 52),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1378, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1266, 44),
      ))
    }

@delegate:ResourceContentHash(1_307_494_042)
internal val Res.string.gems_cook_keep_awake: StringResource by lazy {
      StringResource("string:gems_cook_keep_awake", "gems_cook_keep_awake", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1695, 72),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1435, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1311, 48),
      ))
    }

@delegate:ResourceContentHash(-1_287_658_790)
internal val Res.string.gems_cook_next: StringResource by lazy {
      StringResource("string:gems_cook_next", "gems_cook_next", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1768, 50),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1496, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1360, 34),
      ))
    }

@delegate:ResourceContentHash(35_344_690)
internal val Res.string.gems_cook_prev: StringResource by lazy {
      StringResource("string:gems_cook_prev", "gems_cook_prev", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1819, 34),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1539, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1395, 34),
      ))
    }

@delegate:ResourceContentHash(658_507_873)
internal val Res.string.gems_cook_step_counter: StringResource by lazy {
      StringResource("string:gems_cook_step_counter", "gems_cook_step_counter", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1854, 66),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1578, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1430, 54),
      ))
    }

@delegate:ResourceContentHash(-2_016_218_863)
internal val Res.string.gems_cook_timer_add1: StringResource by lazy {
      StringResource("string:gems_cook_timer_add1", "gems_cook_timer_add1", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1995, 32),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1695, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1539, 32),
      ))
    }

@delegate:ResourceContentHash(-251_723_457)
internal val Res.string.gems_cook_timer_add1_a11y: StringResource by lazy {
      StringResource("string:gems_cook_timer_add1_a11y", "gems_cook_timer_add1_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1921, 73),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1637, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1485, 53),
      ))
    }

@delegate:ResourceContentHash(-2_016_271_222)
internal val Res.string.gems_cook_timer_add5: StringResource by lazy {
      StringResource("string:gems_cook_timer_add5", "gems_cook_timer_add5", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2102, 32),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1790, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1630, 32),
      ))
    }

@delegate:ResourceContentHash(-1_475_945_381)
internal val Res.string.gems_cook_timer_add5_a11y: StringResource by lazy {
      StringResource("string:gems_cook_timer_add5_a11y", "gems_cook_timer_add5_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2028, 73),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1728, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1572, 57),
      ))
    }

@delegate:ResourceContentHash(-1_293_860_406)
internal val Res.string.gems_cook_timer_done: StringResource by lazy {
      StringResource("string:gems_cook_timer_done", "gems_cook_timer_done", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2135, 60),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1823, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1663, 44),
      ))
    }

@delegate:ResourceContentHash(1_622_654_432)
internal val Res.string.gems_cook_timer_label: StringResource by lazy {
      StringResource("string:gems_cook_timer_label", "gems_cook_timer_label", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2196, 53),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1872, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1708, 37),
      ))
    }

@delegate:ResourceContentHash(233_127_419)
internal val Res.string.gems_cook_timer_pause: StringResource by lazy {
      StringResource("string:gems_cook_timer_pause", "gems_cook_timer_pause", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2250, 41),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1914, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1746, 37),
      ))
    }

@delegate:ResourceContentHash(-936_190_685)
internal val Res.string.gems_cook_timer_reset_a11y: StringResource by lazy {
      StringResource("string:gems_cook_timer_reset_a11y", "gems_cook_timer_reset_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2292, 82),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1952, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1784, 50),
      ))
    }

@delegate:ResourceContentHash(89_572_978)
internal val Res.string.gems_cook_timer_start: StringResource by lazy {
      StringResource("string:gems_cook_timer_start", "gems_cook_timer_start", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2375, 41),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2023, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1835, 37),
      ))
    }

@delegate:ResourceContentHash(432_456_531)
internal val Res.string.gems_copied: StringResource by lazy {
      StringResource("string:gems_copied", "gems_copied", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2417, 67),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2065, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1873, 47),
      ))
    }

@delegate:ResourceContentHash(-1_696_555_244)
internal val Res.string.gems_copy_a11y: StringResource by lazy {
      StringResource("string:gems_copy_a11y", "gems_copy_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2485, 30),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2125, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1921, 30),
      ))
    }

@delegate:ResourceContentHash(-2_075_604_251)
internal val Res.string.gems_dan_cat_canada: StringResource by lazy {
      StringResource("string:gems_dan_cat_canada", "gems_dan_cat_canada", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2516, 43),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2156, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1952, 35),
      ))
    }

@delegate:ResourceContentHash(1_644_893_763)
internal val Res.string.gems_dan_cat_community: StringResource by lazy {
      StringResource("string:gems_dan_cat_community", "gems_dan_cat_community", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2560, 54),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2192, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1988, 50),
      ))
    }

@delegate:ResourceContentHash(967_482_993)
internal val Res.string.gems_dan_cat_history: StringResource by lazy {
      StringResource("string:gems_dan_cat_history", "gems_dan_cat_history", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2615, 44),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2247, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2039, 40),
      ))
    }

@delegate:ResourceContentHash(1_979_988_692)
internal val Res.string.gems_dan_cat_iran: StringResource by lazy {
      StringResource("string:gems_dan_cat_iran", "gems_dan_cat_iran", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2660, 41),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2288, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2080, 33),
      ))
    }

@delegate:ResourceContentHash(1_823_796_016)
internal val Res.string.gems_dan_cat_language: StringResource by lazy {
      StringResource("string:gems_dan_cat_language", "gems_dan_cat_language", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2702, 41),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2322, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2114, 41),
      ))
    }

@delegate:ResourceContentHash(1_849_387_101)
internal val Res.string.gems_dan_cat_nature: StringResource by lazy {
      StringResource("string:gems_dan_cat_nature", "gems_dan_cat_nature", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2744, 43),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2360, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2156, 35),
      ))
    }

@delegate:ResourceContentHash(1_757_586_685)
internal val Res.string.gems_dan_empty_desc: StringResource by lazy {
      StringResource("string:gems_dan_empty_desc", "gems_dan_empty_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2788, 115),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2396, 91),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2192, 71),
      ))
    }

@delegate:ResourceContentHash(1_406_273_774)
internal val Res.string.gems_dan_empty_title: StringResource by lazy {
      StringResource("string:gems_dan_empty_title", "gems_dan_empty_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2904, 80),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2488, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2264, 48),
      ))
    }

@delegate:ResourceContentHash(2_056_328_513)
internal val Res.string.gems_dan_search_placeholder: StringResource by lazy {
      StringResource("string:gems_dan_search_placeholder", "gems_dan_search_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2985, 83),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2541, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2313, 51),
      ))
    }

@delegate:ResourceContentHash(1_328_429_455)
internal val Res.string.gems_dan_title: StringResource by lazy {
      StringResource("string:gems_dan_title", "gems_dan_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3069, 50),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2605, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2365, 38),
      ))
    }

@delegate:ResourceContentHash(598_910_424)
internal val Res.string.gems_diff_easy: StringResource by lazy {
      StringResource("string:gems_diff_easy", "gems_diff_easy", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3120, 34),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2644, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2404, 30),
      ))
    }

@delegate:ResourceContentHash(-1_088_428_608)
internal val Res.string.gems_diff_hard: StringResource by lazy {
      StringResource("string:gems_diff_hard", "gems_diff_hard", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3155, 38),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2675, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2435, 30),
      ))
    }

@delegate:ResourceContentHash(-561_810_283)
internal val Res.string.gems_diff_medium: StringResource by lazy {
      StringResource("string:gems_diff_medium", "gems_diff_medium", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3194, 40),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2710, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2466, 32),
      ))
    }

@delegate:ResourceContentHash(1_817_607_458)
internal val Res.string.gems_error: StringResource by lazy {
      StringResource("string:gems_error", "gems_error", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3235, 158),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2743, 106),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2499, 98),
      ))
    }

@delegate:ResourceContentHash(1_216_708_762)
internal val Res.string.gems_fal_draw: StringResource by lazy {
      StringResource("string:gems_fal_draw", "gems_fal_draw", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3462, 53),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2898, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2638, 41),
      ))
    }

@delegate:ResourceContentHash(1_879_529_759)
internal val Res.string.gems_fal_draw_again: StringResource by lazy {
      StringResource("string:gems_fal_draw_again", "gems_fal_draw_again", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3394, 67),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2850, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2598, 39),
      ))
    }

@delegate:ResourceContentHash(-882_153_691)
internal val Res.string.gems_fal_empty_desc: StringResource by lazy {
      StringResource("string:gems_fal_empty_desc", "gems_fal_empty_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3516, 91),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2940, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2680, 75),
      ))
    }

@delegate:ResourceContentHash(-447_909_081)
internal val Res.string.gems_fal_empty_title: StringResource by lazy {
      StringResource("string:gems_fal_empty_title", "gems_fal_empty_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3608, 80),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3012, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2756, 64),
      ))
    }

@delegate:ResourceContentHash(1_469_319_235)
internal val Res.string.gems_fal_prompt_body: StringResource by lazy {
      StringResource("string:gems_fal_prompt_body", "gems_fal_prompt_body", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3689, 396),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3089, 252),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2821, 244),
      ))
    }

@delegate:ResourceContentHash(642_893_109)
internal val Res.string.gems_fal_prompt_title: StringResource by lazy {
      StringResource("string:gems_fal_prompt_title", "gems_fal_prompt_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4086, 49),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3342, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3066, 69),
      ))
    }

@delegate:ResourceContentHash(-60_107_633)
internal val Res.string.gems_fal_reading_label: StringResource by lazy {
      StringResource("string:gems_fal_reading_label", "gems_fal_reading_label", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4136, 62),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3420, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3136, 42),
      ))
    }

@delegate:ResourceContentHash(574_088_478)
internal val Res.string.gems_fal_title: StringResource by lazy {
      StringResource("string:gems_fal_title", "gems_fal_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4199, 42),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3463, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3179, 38),
      ))
    }

@delegate:ResourceContentHash(-1_257_144_093)
internal val Res.string.gems_filter_all: StringResource by lazy {
      StringResource("string:gems_filter_all", "gems_filter_all", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4242, 31),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3502, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3218, 27),
      ))
    }

@delegate:ResourceContentHash(-1_726_339_949)
internal val Res.string.gems_filter_category: StringResource by lazy {
      StringResource("string:gems_filter_category", "gems_filter_category", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4274, 56),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3534, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3246, 40),
      ))
    }

@delegate:ResourceContentHash(963_170_672)
internal val Res.string.gems_filter_difficulty: StringResource by lazy {
      StringResource("string:gems_filter_difficulty", "gems_filter_difficulty", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4331, 42),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3579, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3287, 46),
      ))
    }

@delegate:ResourceContentHash(1_684_707_708)
internal val Res.string.gems_filter_sort: StringResource by lazy {
      StringResource("string:gems_filter_sort", "gems_filter_sort", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4374, 52),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3626, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3334, 32),
      ))
    }

@delegate:ResourceContentHash(958_506_254)
internal val Res.string.gems_filter_time: StringResource by lazy {
      StringResource("string:gems_filter_time", "gems_filter_time", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4427, 52),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3659, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3367, 36),
      ))
    }

@delegate:ResourceContentHash(1_765_083_876)
internal val Res.string.gems_find_ingredients: StringResource by lazy {
      StringResource("string:gems_find_ingredients", "gems_find_ingredients", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4480, 109),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3700, 89),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3404, 65),
      ))
    }

@delegate:ResourceContentHash(1_522_221_989)
internal val Res.string.gems_ingredients_title: StringResource by lazy {
      StringResource("string:gems_ingredients_title", "gems_ingredients_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4590, 54),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3790, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3470, 46),
      ))
    }

@delegate:ResourceContentHash(-421_076_825)
internal val Res.string.gems_jokes_counter: StringResource by lazy {
      StringResource("string:gems_jokes_counter", "gems_jokes_counter", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4645, 42),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3837, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3517, 42),
      ))
    }

@delegate:ResourceContentHash(-1_844_693_459)
internal val Res.string.gems_jokes_empty_desc: StringResource by lazy {
      StringResource("string:gems_jokes_empty_desc", "gems_jokes_empty_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4688, 137),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3880, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3560, 77),
      ))
    }

@delegate:ResourceContentHash(-74_123_267)
internal val Res.string.gems_jokes_empty_title: StringResource by lazy {
      StringResource("string:gems_jokes_empty_title", "gems_jokes_empty_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4826, 62),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3966, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3638, 50),
      ))
    }

@delegate:ResourceContentHash(1_176_783_609)
internal val Res.string.gems_jokes_title: StringResource by lazy {
      StringResource("string:gems_jokes_title", "gems_jokes_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4889, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4029, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3689, 44),
      ))
    }

@delegate:ResourceContentHash(2_094_185_354)
internal val Res.string.gems_like_a11y: StringResource by lazy {
      StringResource("string:gems_like_a11y", "gems_like_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4938, 42),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4078, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3734, 30),
      ))
    }

@delegate:ResourceContentHash(1_707_219_138)
internal val Res.string.gems_minutes: StringResource by lazy {
      StringResource("string:gems_minutes", "gems_minutes", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4981, 40),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4109, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3765, 32),
      ))
    }

@delegate:ResourceContentHash(-1_571_576_567)
internal val Res.string.gems_more_a11y: StringResource by lazy {
      StringResource("string:gems_more_a11y", "gems_more_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5022, 62),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4142, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3798, 38),
      ))
    }

@delegate:ResourceContentHash(2_062_384_442)
internal val Res.string.gems_poem_form_ghazal: StringResource by lazy {
      StringResource("string:gems_poem_form_ghazal", "gems_poem_form_ghazal", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5085, 37),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4189, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3837, 37),
      ))
    }

@delegate:ResourceContentHash(-12_813_280)
internal val Res.string.gems_poem_form_masnavi: StringResource by lazy {
      StringResource("string:gems_poem_form_masnavi", "gems_poem_form_masnavi", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5123, 46),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4227, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3875, 42),
      ))
    }

@delegate:ResourceContentHash(-1_433_547_456)
internal val Res.string.gems_poem_form_other: StringResource by lazy {
      StringResource("string:gems_poem_form_other", "gems_poem_form_other", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5170, 36),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4270, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3918, 36),
      ))
    }

@delegate:ResourceContentHash(-908_803_409)
internal val Res.string.gems_poem_form_qasideh: StringResource by lazy {
      StringResource("string:gems_poem_form_qasideh", "gems_poem_form_qasideh", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5207, 46),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4307, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3955, 38),
      ))
    }

@delegate:ResourceContentHash(1_152_858_118)
internal val Res.string.gems_poem_form_qete: StringResource by lazy {
      StringResource("string:gems_poem_form_qete", "gems_poem_form_qete", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5254, 39),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4346, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3994, 39),
      ))
    }

@delegate:ResourceContentHash(-1_188_199_470)
internal val Res.string.gems_poem_form_robaei: StringResource by lazy {
      StringResource("string:gems_poem_form_robaei", "gems_poem_form_robaei", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5294, 45),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4386, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4034, 41),
      ))
    }

@delegate:ResourceContentHash(-679_192_205)
internal val Res.string.gems_poem_original: StringResource by lazy {
      StringResource("string:gems_poem_original", "gems_poem_original", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5340, 46),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4428, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4076, 38),
      ))
    }

@delegate:ResourceContentHash(181_016_710)
internal val Res.string.gems_poem_translation: StringResource by lazy {
      StringResource("string:gems_poem_translation", "gems_poem_translation", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5387, 45),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4475, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4115, 45),
      ))
    }

@delegate:ResourceContentHash(-140_960_105)
internal val Res.string.gems_poems_empty_desc: StringResource by lazy {
      StringResource("string:gems_poems_empty_desc", "gems_poems_empty_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5433, 125),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4521, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4161, 77),
      ))
    }

@delegate:ResourceContentHash(1_630_834_564)
internal val Res.string.gems_poems_empty_title: StringResource by lazy {
      StringResource("string:gems_poems_empty_title", "gems_poems_empty_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5559, 66),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4607, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4239, 46),
      ))
    }

@delegate:ResourceContentHash(644_880_932)
internal val Res.string.gems_poetry_empty_desc: StringResource by lazy {
      StringResource("string:gems_poetry_empty_desc", "gems_poetry_empty_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5626, 122),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4678, 98),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4286, 94),
      ))
    }

@delegate:ResourceContentHash(140_825_300)
internal val Res.string.gems_poetry_empty_title: StringResource by lazy {
      StringResource("string:gems_poetry_empty_title", "gems_poetry_empty_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5749, 71),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4777, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4381, 47),
      ))
    }

@delegate:ResourceContentHash(118_888_073)
internal val Res.string.gems_poetry_title: StringResource by lazy {
      StringResource("string:gems_poetry_title", "gems_poetry_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5821, 49),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4849, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4429, 45),
      ))
    }

@delegate:ResourceContentHash(1_688_806_308)
internal val Res.string.gems_rcat_appetizer: StringResource by lazy {
      StringResource("string:gems_rcat_appetizer", "gems_rcat_appetizer", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5871, 47),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4895, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4475, 43),
      ))
    }

@delegate:ResourceContentHash(-1_875_151_698)
internal val Res.string.gems_rcat_bread: StringResource by lazy {
      StringResource("string:gems_rcat_bread", "gems_rcat_bread", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5919, 31),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4935, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4519, 31),
      ))
    }

@delegate:ResourceContentHash(-1_577_862_565)
internal val Res.string.gems_rcat_drink: StringResource by lazy {
      StringResource("string:gems_rcat_drink", "gems_rcat_drink", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5951, 43),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4967, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4551, 31),
      ))
    }

@delegate:ResourceContentHash(-1_521_513_839)
internal val Res.string.gems_rcat_other: StringResource by lazy {
      StringResource("string:gems_rcat_other", "gems_rcat_other", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5995, 35),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5003, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4583, 31),
      ))
    }

@delegate:ResourceContentHash(1_827_962_203)
internal val Res.string.gems_rcat_preserve: StringResource by lazy {
      StringResource("string:gems_rcat_preserve", "gems_rcat_preserve", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6031, 54),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5035, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4615, 38),
      ))
    }

@delegate:ResourceContentHash(1_537_492_782)
internal val Res.string.gems_rcat_rice: StringResource by lazy {
      StringResource("string:gems_rcat_rice", "gems_rcat_rice", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6086, 46),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5074, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4654, 38),
      ))
    }

@delegate:ResourceContentHash(1_137_449_386)
internal val Res.string.gems_rcat_stew: StringResource by lazy {
      StringResource("string:gems_rcat_stew", "gems_rcat_stew", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6133, 38),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5113, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4693, 30),
      ))
    }

@delegate:ResourceContentHash(-1_440_460_943)
internal val Res.string.gems_rcat_sweet: StringResource by lazy {
      StringResource("string:gems_rcat_sweet", "gems_rcat_sweet", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6172, 39),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5148, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4724, 31),
      ))
    }

@delegate:ResourceContentHash(-2_119_596_674)
internal val Res.string.gems_recipe_image_a11y: StringResource by lazy {
      StringResource("string:gems_recipe_image_a11y", "gems_recipe_image_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6212, 50),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5184, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4756, 46),
      ))
    }

@delegate:ResourceContentHash(-307_627_450)
internal val Res.string.gems_recipe_not_found: StringResource by lazy {
      StringResource("string:gems_recipe_not_found", "gems_recipe_not_found", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6263, 73),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5243, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4803, 53),
      ))
    }

@delegate:ResourceContentHash(-1_657_293_051)
internal val Res.string.gems_recipes_empty_desc: StringResource by lazy {
      StringResource("string:gems_recipes_empty_desc", "gems_recipes_empty_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6337, 127),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5301, 95),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4857, 75),
      ))
    }

@delegate:ResourceContentHash(-2_062_820_667)
internal val Res.string.gems_recipes_empty_title: StringResource by lazy {
      StringResource("string:gems_recipes_empty_title", "gems_recipes_empty_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6465, 80),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5397, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4933, 56),
      ))
    }

@delegate:ResourceContentHash(-1_728_197_147)
internal val Res.string.gems_recipes_search_placeholder: StringResource by lazy {
      StringResource("string:gems_recipes_search_placeholder", "gems_recipes_search_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6546, 87),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5462, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4990, 59),
      ))
    }

@delegate:ResourceContentHash(-855_764_040)
internal val Res.string.gems_recipes_title: StringResource by lazy {
      StringResource("string:gems_recipes_title", "gems_recipes_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6634, 62),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5534, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5050, 50),
      ))
    }

@delegate:ResourceContentHash(1_625_393_502)
internal val Res.string.gems_region_all: StringResource by lazy {
      StringResource("string:gems_region_all", "gems_region_all", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6697, 51),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5589, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5101, 35),
      ))
    }

@delegate:ResourceContentHash(-1_417_394_665)
internal val Res.string.gems_region_ardabil: StringResource by lazy {
      StringResource("string:gems_region_ardabil", "gems_region_ardabil", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6749, 43),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5633, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5137, 39),
      ))
    }

@delegate:ResourceContentHash(-444_195_813)
internal val Res.string.gems_region_azerbaijan: StringResource by lazy {
      StringResource("string:gems_region_azerbaijan", "gems_region_azerbaijan", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6793, 54),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5673, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5177, 46),
      ))
    }

@delegate:ResourceContentHash(-386_338_406)
internal val Res.string.gems_region_fars: StringResource by lazy {
      StringResource("string:gems_region_fars", "gems_region_fars", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6848, 36),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5720, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5224, 32),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("gems_adult_chip", Res.string.gems_adult_chip)
  map.put("gems_age_gate_body", Res.string.gems_age_gate_body)
  map.put("gems_age_gate_cancel", Res.string.gems_age_gate_cancel)
  map.put("gems_age_gate_confirm", Res.string.gems_age_gate_confirm)
  map.put("gems_age_gate_note", Res.string.gems_age_gate_note)
  map.put("gems_age_gate_title", Res.string.gems_age_gate_title)
  map.put("gems_any_option", Res.string.gems_any_option)
  map.put("gems_back_a11y", Res.string.gems_back_a11y)
  map.put("gems_cat_classic", Res.string.gems_cat_classic)
  map.put("gems_cat_family", Res.string.gems_cat_family)
  map.put("gems_cat_nostalgia", Res.string.gems_cat_nostalgia)
  map.put("gems_cat_observational", Res.string.gems_cat_observational)
  map.put("gems_cat_wordplay", Res.string.gems_cat_wordplay)
  map.put("gems_coming_soon_desc", Res.string.gems_coming_soon_desc)
  map.put("gems_coming_soon_title", Res.string.gems_coming_soon_title)
  map.put("gems_cook_close_a11y", Res.string.gems_cook_close_a11y)
  map.put("gems_cook_finish", Res.string.gems_cook_finish)
  map.put("gems_cook_image_a11y", Res.string.gems_cook_image_a11y)
  map.put("gems_cook_keep_awake", Res.string.gems_cook_keep_awake)
  map.put("gems_cook_next", Res.string.gems_cook_next)
  map.put("gems_cook_prev", Res.string.gems_cook_prev)
  map.put("gems_cook_step_counter", Res.string.gems_cook_step_counter)
  map.put("gems_cook_timer_add1", Res.string.gems_cook_timer_add1)
  map.put("gems_cook_timer_add1_a11y", Res.string.gems_cook_timer_add1_a11y)
  map.put("gems_cook_timer_add5", Res.string.gems_cook_timer_add5)
  map.put("gems_cook_timer_add5_a11y", Res.string.gems_cook_timer_add5_a11y)
  map.put("gems_cook_timer_done", Res.string.gems_cook_timer_done)
  map.put("gems_cook_timer_label", Res.string.gems_cook_timer_label)
  map.put("gems_cook_timer_pause", Res.string.gems_cook_timer_pause)
  map.put("gems_cook_timer_reset_a11y", Res.string.gems_cook_timer_reset_a11y)
  map.put("gems_cook_timer_start", Res.string.gems_cook_timer_start)
  map.put("gems_copied", Res.string.gems_copied)
  map.put("gems_copy_a11y", Res.string.gems_copy_a11y)
  map.put("gems_dan_cat_canada", Res.string.gems_dan_cat_canada)
  map.put("gems_dan_cat_community", Res.string.gems_dan_cat_community)
  map.put("gems_dan_cat_history", Res.string.gems_dan_cat_history)
  map.put("gems_dan_cat_iran", Res.string.gems_dan_cat_iran)
  map.put("gems_dan_cat_language", Res.string.gems_dan_cat_language)
  map.put("gems_dan_cat_nature", Res.string.gems_dan_cat_nature)
  map.put("gems_dan_empty_desc", Res.string.gems_dan_empty_desc)
  map.put("gems_dan_empty_title", Res.string.gems_dan_empty_title)
  map.put("gems_dan_search_placeholder", Res.string.gems_dan_search_placeholder)
  map.put("gems_dan_title", Res.string.gems_dan_title)
  map.put("gems_diff_easy", Res.string.gems_diff_easy)
  map.put("gems_diff_hard", Res.string.gems_diff_hard)
  map.put("gems_diff_medium", Res.string.gems_diff_medium)
  map.put("gems_error", Res.string.gems_error)
  map.put("gems_fal_draw", Res.string.gems_fal_draw)
  map.put("gems_fal_draw_again", Res.string.gems_fal_draw_again)
  map.put("gems_fal_empty_desc", Res.string.gems_fal_empty_desc)
  map.put("gems_fal_empty_title", Res.string.gems_fal_empty_title)
  map.put("gems_fal_prompt_body", Res.string.gems_fal_prompt_body)
  map.put("gems_fal_prompt_title", Res.string.gems_fal_prompt_title)
  map.put("gems_fal_reading_label", Res.string.gems_fal_reading_label)
  map.put("gems_fal_title", Res.string.gems_fal_title)
  map.put("gems_filter_all", Res.string.gems_filter_all)
  map.put("gems_filter_category", Res.string.gems_filter_category)
  map.put("gems_filter_difficulty", Res.string.gems_filter_difficulty)
  map.put("gems_filter_sort", Res.string.gems_filter_sort)
  map.put("gems_filter_time", Res.string.gems_filter_time)
  map.put("gems_find_ingredients", Res.string.gems_find_ingredients)
  map.put("gems_ingredients_title", Res.string.gems_ingredients_title)
  map.put("gems_jokes_counter", Res.string.gems_jokes_counter)
  map.put("gems_jokes_empty_desc", Res.string.gems_jokes_empty_desc)
  map.put("gems_jokes_empty_title", Res.string.gems_jokes_empty_title)
  map.put("gems_jokes_title", Res.string.gems_jokes_title)
  map.put("gems_like_a11y", Res.string.gems_like_a11y)
  map.put("gems_minutes", Res.string.gems_minutes)
  map.put("gems_more_a11y", Res.string.gems_more_a11y)
  map.put("gems_poem_form_ghazal", Res.string.gems_poem_form_ghazal)
  map.put("gems_poem_form_masnavi", Res.string.gems_poem_form_masnavi)
  map.put("gems_poem_form_other", Res.string.gems_poem_form_other)
  map.put("gems_poem_form_qasideh", Res.string.gems_poem_form_qasideh)
  map.put("gems_poem_form_qete", Res.string.gems_poem_form_qete)
  map.put("gems_poem_form_robaei", Res.string.gems_poem_form_robaei)
  map.put("gems_poem_original", Res.string.gems_poem_original)
  map.put("gems_poem_translation", Res.string.gems_poem_translation)
  map.put("gems_poems_empty_desc", Res.string.gems_poems_empty_desc)
  map.put("gems_poems_empty_title", Res.string.gems_poems_empty_title)
  map.put("gems_poetry_empty_desc", Res.string.gems_poetry_empty_desc)
  map.put("gems_poetry_empty_title", Res.string.gems_poetry_empty_title)
  map.put("gems_poetry_title", Res.string.gems_poetry_title)
  map.put("gems_rcat_appetizer", Res.string.gems_rcat_appetizer)
  map.put("gems_rcat_bread", Res.string.gems_rcat_bread)
  map.put("gems_rcat_drink", Res.string.gems_rcat_drink)
  map.put("gems_rcat_other", Res.string.gems_rcat_other)
  map.put("gems_rcat_preserve", Res.string.gems_rcat_preserve)
  map.put("gems_rcat_rice", Res.string.gems_rcat_rice)
  map.put("gems_rcat_stew", Res.string.gems_rcat_stew)
  map.put("gems_rcat_sweet", Res.string.gems_rcat_sweet)
  map.put("gems_recipe_image_a11y", Res.string.gems_recipe_image_a11y)
  map.put("gems_recipe_not_found", Res.string.gems_recipe_not_found)
  map.put("gems_recipes_empty_desc", Res.string.gems_recipes_empty_desc)
  map.put("gems_recipes_empty_title", Res.string.gems_recipes_empty_title)
  map.put("gems_recipes_search_placeholder", Res.string.gems_recipes_search_placeholder)
  map.put("gems_recipes_title", Res.string.gems_recipes_title)
  map.put("gems_region_all", Res.string.gems_region_all)
  map.put("gems_region_ardabil", Res.string.gems_region_ardabil)
  map.put("gems_region_azerbaijan", Res.string.gems_region_azerbaijan)
  map.put("gems_region_fars", Res.string.gems_region_fars)
}
